<template>
	<el-dialog :visible.sync="showUserDetail" width="80%">
		
		<x-table
			:tableData="tableData"
			:tableHeaders="tableHeaders"
		></x-table>
	</el-dialog>
</template>
<script type="text/javascript">
import {
	peopleList,
} from '@/api/people';
export default {
	data() {
		return {
			showUserDetail: false,
			pageModel: {
				page: 1,
				size: 20
			},
			tableData: [],
			total: 0,
			tableHeaders: [{
				headerKey: 'id',
				headerName: 'ID',
				width: 60
			}, {
				headerKey: 'avatar',
				headerName: '头像',
				image: true
			}, {
				headerKey: 'realName',
				headerName: '用户名',
			}, {
				headerKey: 'nickName',
				headerName: '昵称',
			}, {
				headerKey: 'mobile',
				headerName: '手机号',
			}, {
				headerKey: 'inviteNum',
				headerName: '邀请人数'
			}, {
				headerKey: 'signInDayNum',
				headerName: '打卡天数'
			}, {
				headerKey: 'coinNum',
				headerName: '金币数量'
			}, {
				headerKey: 'createdAt',
				headerName: '注册时间'
			}],
			
		}
	},
	methods: {
		fetchList(userId) {

			peopleList({
				...this.pageModel,

				userId: Number(userId)
			}).then(res => {
				this.tableData = res.data.data.users

				this.showUserDetail = true
			})
		},
		
	},
	mounted() {

	}
}
</script>

<style lang="less">
	
</style>